import { Injectable } from '@angular/core';
import { PortalFieldConfig } from '@portal/form/data-access';
import { ESignatureModelKeys } from '../const/form-field-key.const';
import { E_SIGNATURE } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class ESignatureFormConfigService {
  initESignatureFieldConfig(): PortalFieldConfig[] {
    return [
      {
        template: `
          <p class="portal-paragraph">Upload or draw your signature</p>
          <ul class="list-disc pl-5">
            <li>File format: PNG, JPG and JPEG</li>
            <li>Each file max 5MB</li>
            <li>File name: Max 150 characters, only the following characters: ! - _ . * ' ( ) & $ @ = ; : + , ?.</li>
          </ul>
        `,
      },
      {
        key: ESignatureModelKeys.signature,
        type: 'signature',
        validators: { validation: ['requiredFile', 'fileName', 'minSizeFile', 'maxSizeFile'] },
        className: 'field-columns',
        props: {
          required: true,
          max: E_SIGNATURE.MAX_SIZE,
          min: E_SIGNATURE.MIN_SIZE,
          confirmBeforeChange: true,
          acceptMimeTypes: Array.from<string>(E_SIGNATURE.MIME_TYPE),
        },
      },
    ];
  }
}
